import type { TPlayerRegistrationResponse } from '@lucimark/shared/database/players-directory-schema'

/**
 * Cached pairing rows skip `setRegistration` on cold boot, so `REGISTRATION` never fires and
 * `AuthenticationService` never sets `_registrationCode`. When true, call `setRegistration(reg)` once.
 *
 * Uses in-memory auth registration code (not Vue state): web may pre-fill `state.registrationCode`
 * from localStorage for first paint without having called `setRegistration` yet.
 */
export function shouldHydrateCachedPairingRegistration(
  reg: TPlayerRegistrationResponse | null | undefined,
  authRegistrationCodeInMemory: string | null
): boolean {
  if (reg == null) { return false }
  if (reg.tenantId != null) { return false }
  if (reg.secret == null || reg.secret === '') { return false }
  if (authRegistrationCodeInMemory != null) { return false }
  return true
}
